import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://xcaocmpfqkphwpcdndsc.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhjYW9jbXBmcWtwaHdwY2RuZHNjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUwMDUwNjEsImV4cCI6MjA2MDU4MTA2MX0.CxBdzbRNExBqLGP_I5WDWR51YqYOu6Mf8Ty0X-MG4-I';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
